import BaseLayout from "../../layouts/BaseLayout";
import { Chat } from "@vojomo-core/shared";
import styles from "./Chat.module.css";

export function AgentCreator(): React.ReactElement {
  return (
    <BaseLayout pageTitle="Agent Creator">
      <div>
        <h3 className="mb-0 pb-0">Agent Creator</h3>
        <div className={styles.modusContainer}>
          <Chat agent="PromptGenerationAgency" showTranscriptIcon={true} />
        </div>
      </div>
    </BaseLayout>
  );
}
